/**
 * Ищем контейнер
 * @param target
 * @returns {*}
 */
function findContainer(target) {
	if (!target) return false;
	return document.querySelector(target)
}

/**
 * Вытаскиваем все дата атрибуты у элемента
 * @param node
 * @param isRemoveDataName
 * @returns {{}}
 */
function getDataAttributes(node, isRemoveDataName = false) {
	if (!node) return false;

	let obj = {},
		arr = [].filter.call(node.attributes, function (at) {
			return /^data-/.test(at.name);
		});

	if (arr.length) {
		arr.forEach(function (v) {
			let name = v.name;
			if (isRemoveDataName) name = name.slice(5);
			obj[name] = v.value
		});
	}

	return obj;
}

/**
 * Получаем массив из строки
 * @param string
 * @param isInt
 * @returns {*}
 */
function setParamArray(string, isInt = false) {
	let arr = string.split(',');

	if (isInt) {
		return arr.map((item) => {
			return parseInt('' + item)
		})
	} else {
		return  arr;
	}
}

/**
 * Глубокое объединение объектов
 * @param objects
 * @returns {*}
 */
function mergeDeepObject(...objects) {
	const isObject = obj => obj && typeof obj === 'object';

	return objects.reduce((prev, obj) => {
		Object.keys(obj).forEach(key => {
			const pVal = prev[key];
			const oVal = obj[key];

			if (Array.isArray(pVal) && Array.isArray(oVal)) {
				prev[key] = pVal.concat(...oVal);
			}
			else if (isObject(pVal) && isObject(oVal)) {
				prev[key] = mergeDeepObject(pVal, oVal);
			}
			else {
				prev[key] = oVal;
			}
		});

		return prev;
	}, {});
}

function transliterate (text, enToRu) {
	let ru = "й ц у к е н г ш щ з х ъ ф ы в а п р о л д ж э я ч с м и т ь б ю".split(/ +/g);
	let en = "q w e r t y u i o p [ ] a s d f g h j k l ; ' z x c v b n m , .".split(/ +/g);
	let x;

	for (x = 0; x < ru.length; x++) {
		text = text.split(enToRu ? en[x] : ru[x]).join(enToRu ? ru[x] : en[x]);
		text = text.split(enToRu ? en[x].toUpperCase() : ru[x].toUpperCase()).join(enToRu ? ru[x].toUpperCase() : en[x].toUpperCase());
	}

	return text;
}

function translit (word, enToRu) {
	let answer = ""
		, a = {};

	a["Ё"]="YO";a["Й"]="I";a["Ц"]="TS";a["У"]="U";a["К"]="K";a["Е"]="E";a["Н"]="N";a["Г"]="G";a["Ш"]="SH";a["Щ"]="SCH";a["З"]="Z";a["Х"]="H";a["Ъ"]="'";
	a["ё"]="yo";a["й"]="i";a["ц"]="ts";a["у"]="u";a["к"]="k";a["е"]="e";a["н"]="n";a["г"]="g";a["ш"]="sh";a["щ"]="sch";a["з"]="z";a["х"]="h";a["ъ"]="'";
	a["Ф"]="F";a["Ы"]="I";a["В"]="V";a["А"]="a";a["П"]="P";a["Р"]="R";a["О"]="O";a["Л"]="L";a["Д"]="D";a["Ж"]="ZH";a["Э"]="E";
	a["ф"]="f";a["ы"]="i";a["в"]="v";a["а"]="a";a["п"]="p";a["р"]="r";a["о"]="o";a["л"]="l";a["д"]="d";a["ж"]="zh";a["э"]="e";
	a["Я"]="Ya";a["Ч"]="CH";a["С"]="S";a["М"]="M";a["И"]="I";a["Т"]="T";a["Ь"]="'";a["Б"]="B";a["Ю"]="YU";
	a["я"]="ya";a["ч"]="ch";a["с"]="s";a["м"]="m";a["и"]="i";a["т"]="t";a["ь"]="'";a["б"]="b";a["ю"]="yu";

	if (enToRu) {
		let res = [];
		for(let k in a) {
			res[a[k]] = k;
		}
		a = res;
	}

	for (let i in word){
		if (word.hasOwnProperty(i)) {
			if (a[word[i]] === undefined){
				answer += word[i];
			} else {
				answer += a[word[i]];
			}
		}
	}
	return answer;
}

export {findContainer, getDataAttributes, setParamArray, mergeDeepObject, transliterate, translit}
